import { Model } from '@shared/models/model';
import { Expose } from 'class-transformer';
export class CustomerTransactions extends Model {
    @Expose() totalPrice: number;
    @Expose() transactionDate: Date;
    @Expose() balanceId: string;
    @Expose() transactionTime: string;
    @Expose() transactionId: number;
    @Expose() transactionType: string;
}